"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCompaniesAssociationsOptions;

var _ = require("_");

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _CompaniesStore = _interopRequireDefault(require("crm_data/companies/CompaniesStore"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _CompaniesChildrenStore = _interopRequireDefault(require("crm_data/companies/CompaniesChildrenStore"));

var _CompaniesSearchAPIQuery = _interopRequireDefault(require("crm_data/companies/api/CompaniesSearchAPIQuery"));

var _AssociationOptionsDependencyHelpers = require("crm_data/associations/AssociationOptionsDependencyHelpers");

var _EngagementAssociationsConstants = require("crm_data/associations/EngagementAssociationsConstants");

function getParentCompanyRecord(parentCompanyId) {
  var companyRecord = _CompaniesStore.default.get(parentCompanyId);

  if (!companyRecord) {
    return [];
  }

  return (0, _AssociationOptionsDependencyHelpers.parseMatches)((0, _immutable.List)([companyRecord]));
}

function getChildCompanyRecordsFromElasticSearch(subjectId, objectType, searchText) {
  var companiesQuery = _CompaniesSearchAPIQuery.default.associatedWithChidren(subjectId, _EngagementAssociationsConstants.MAX_OPTION_SIZE, searchText);

  var associatedIds = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromElasticSearch)(subjectId, companiesQuery, objectType);
  var associatedCompanyIds = associatedIds && associatedIds.get('companies');

  if (!associatedCompanyIds) {
    return (0, _immutable.List)();
  }

  if (associatedCompanyIds.size) {
    return _CompaniesStore.default.get(associatedCompanyIds);
  }

  return (0, _immutable.List)();
}

function getChildCompanyRecords(objectType, subjectId, searchText) {
  var associatedRecords = (0, _immutable.List)();

  var childCompanyIds = _CompaniesChildrenStore.default.get(subjectId);

  var results = childCompanyIds && childCompanyIds.get('results');

  if (!results || !results.size) {
    return [];
  }

  if (results.size <= _EngagementAssociationsConstants.ASSOC_STORE_SEARCH_MAX) {
    associatedRecords = _CompaniesStore.default.get(childCompanyIds.get('results')).filterNot(_.isUndefined);
  } else {
    associatedRecords = getChildCompanyRecordsFromElasticSearch(subjectId, objectType, searchText);
  }

  return (0, _AssociationOptionsDependencyHelpers.parseMatches)(associatedRecords);
}

function getAssociatedCompanyRecords(subjectId, subject, objectType, searchText) {
  var parentCompanyId = Number((0, _ImmutableModel.getProperty)(subject, 'hs_parent_company_id'));
  var companyOptions = (0, _immutable.List)();

  if (parentCompanyId) {
    companyOptions = companyOptions.concat(getParentCompanyRecord(parentCompanyId));
  }

  companyOptions = companyOptions.concat(getChildCompanyRecords(objectType, subjectId, searchText));
  var subjectMatch = (0, _AssociationOptionsDependencyHelpers.parseMatches)((0, _immutable.List)([subject]));
  return companyOptions.concat(subjectMatch);
}

function getAlreadyAssociatedCompanies(values) {
  var companyIds = (0, _AssociationOptionsDependencyHelpers.getIdsFromOptions)(values, 'companyValues');
  var alreadyAssociatedCompanies = companyIds ? _CompaniesStore.default.get(companyIds) : (0, _immutable.List)();
  return (0, _AssociationOptionsDependencyHelpers.parseMatches)(alreadyAssociatedCompanies);
}

function getCompaniesAssociationsOptions(_ref) {
  var objectType = _ref.objectType,
      subjectId = _ref.subjectId,
      subject = _ref.subject,
      state = _ref.state,
      values = _ref.values;
  var debouncedSearchTextForElasticSearch = state.debouncedSearchTextForElasticSearch;
  var companyOptions = [];
  var alreadyAssociatedCompanies = getAlreadyAssociatedCompanies(values);

  if (objectType === _ObjectTypes.CONTACT) {
    var associatedCompanyId = (0, _ImmutableModel.getProperty)(subject, 'associatedcompanyid');

    if (associatedCompanyId) {
      companyOptions = (0, _AssociationOptionsDependencyHelpers.getAssociatedRecordsFromIds)((0, _immutable.List)([associatedCompanyId]), _ObjectTypes.COMPANY);
    }
  } else if (objectType === _ObjectTypes.COMPANY) {
    companyOptions = getAssociatedCompanyRecords(subjectId, subject, objectType, debouncedSearchTextForElasticSearch);
  } else if ([_ObjectTypes.DEAL, _ObjectTypes.TICKET].includes(objectType)) {
    companyOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromAssociationsStore)(objectType, subjectId, objectType + "_TO_COMPANY", _ObjectTypes.COMPANY);
  }

  var allCompanyOptions = (0, _immutable.List)(alreadyAssociatedCompanies).concat(companyOptions || []).reduce(function (map, option) {
    return map.set(option.id, option);
  }, (0, _immutable.Map)()).sortBy(function (match) {
    return match.text.toLowerCase();
  }).toArray();
  return allCompanyOptions;
}

module.exports = exports.default;